module.exports = __webpack_public_path__ + "assets/edit-green-circle.9335938b.svg";